// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__Veo2g","medium":"badge_medium__nWt1P"};